const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const safeSend = (url, body) => {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${API}${url}`);
    xhr.setRequestHeader('Content-Type', 'application/json');
    try {
      xhr.send(JSON.stringify(body));
    } catch (e) {
      // Platform wrapper postMessage errors — XHR still fires
    }
  } catch {
    // Analytics setup error — non-critical, silently ignored
  }
};

export const trackPageView = (page) => {
  safeSend('/track/pageview', { page, referrer: document.referrer || null, user_agent: navigator.userAgent || '' });
};

export const trackClick = (element, page) => {
  safeSend('/track/click', { element, page });
};

export const trackVisitor = () => {
  safeSend('/track/visitor', { user_agent: navigator.userAgent || '' });
};
